import React from "react";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import ResearchSnapshotTable from "./ResearchSnapshotTable";

const ResearchSnapshot = (props) => {
    const { role, snapshot, editResponse } = props;
    return (
        <Container>
            <Grid container justifyContent="flex-end" alignItems="center" spacing={8} style={{ marginBottom: "10px" }}>
                <Grid item>
                    <Buttons></Buttons>
                </Grid>
            </Grid>
            <Divider />
            <ResearchSnapshotTable editResponse={editResponse} snapshots={snapshot} role={role} />
        </Container>
    );
};

const Container = styled("div")({
    minHeight: "100px",
    border: "1px solid #dbdbdb",
    padding: "15px",
});

const Buttons = styled("div")({
    alignSelf: "center",
    marginRight: "20px",
});

export default ResearchSnapshot;
